import React from 'react';
import { OperatorField, getOperatorFieldName } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';

export interface ConfigOperatorProps {
    operatorFieldList: OperatorField[];
    value?: OperatorField;
    onChange: (value?: OperatorField) => void;
}

const OperatorFieldSection: React.FC<ConfigOperatorProps> = ({
    operatorFieldList,
    value: selectedOperatorField,
    onChange,
}) => {
    const operatorRadioButtonList: RadioButtonEntry<OperatorField>[] = operatorFieldList.map(
        (field) => {
            return { value: field, label: getOperatorFieldName(field) };
        },
    );
    const onOperatorChange = (element: OperatorField) =>
        onChange(element === selectedOperatorField ? undefined : element);

    return (
        <ConfigSection title="Operator">
            <RadioButtonList
                list={operatorRadioButtonList}
                selectedValue={selectedOperatorField}
                onChange={onOperatorChange}
            />
        </ConfigSection>
    );
};

export default OperatorFieldSection;
